<template>
    <section>
        <sui-segment basic>
            <sui-button
                v-if="factoringCompany.id && !factoringCompany.editing && canAddComments"
                primary
                icon="plus"
                floated="right"
                content="Agregar comentario"
                :disabled="addingComment"
                @click="addComment()"/>
            <h2 is="sui-header" floated="left" color="grey">Comentarios</h2>
        </sui-segment>
        <sui-divider hidden />

        <div v-show="factoringCompany.id && !factoringCompany.editing && canAddComments && addingComment">
            <sui-divider hidden />
            <h4 class="ui dividing header blue">
              <i class="comment outline icon"></i>
              <div class="content">Añadir comentario</div>
            </h4>
            <sui-form>
                <sui-form-field :class="{'error': errors}">
                  <label></label>
                    <textarea v-model="record.comment" id="comment" type="text" rows="5" placeholder="Escriba un comentario" class="field-value form-control"></textarea>
                    <div class="ui pointing red basic label" v-if="errors">
                      {{ errors }}
                    </div>
                </sui-form-field>
            </sui-form>
            <sui-button size="mini"
                v-show="factoringCompany.id && !factoringCompany.editing"
                content="Agregar"
                color="green"
                @click="saveComment()"
                style="margin-top: 10px;"
                :class="{'disabled': !record.comment}"/>
            <sui-button size="mini"
                v-show="addingComment"
                content="Cancelar"
                negative
                @click="cancelAddComment()"
                style="margin-top: 10px;"/>
        </div>
        <sui-comment-group>
            <sui-comment v-for="(comment, indexComment) of factoringCompany.comments" :key="indexComment">
              <sui-comment-content>
                <span is="sui-comment-author" class="ui header blue">{{comment.added_by}}</span>
                <sui-comment-metadata>
                  <div>{{comment.added_on}}</div>
                </sui-comment-metadata>
                <sui-comment-text>{{comment.comment}}</sui-comment-text>
              </sui-comment-content>
            </sui-comment>
        </sui-comment-group>
    </section>
</template>

<script>

// import Mixins from '@/mixins/index.js'
import Utils from '@/common/Utils.js'
import FactoringCompanyService from '@/services/FactoringCompanyService'

export default {
    name: 'Comments',
    inject: ['loadRecord'],
    // mixins: [ Mixins ],

    props: {
        factoringCompany: {
            type: Object, default: () => {}
        },

        dirty: {
            type: Boolean, default: false
        }
    },

    data () {
        return {
            recordName: 'factoringCompany',
            record: {},
            errors: '',
            addingComment: false
        }
    },

    methods: {
        gotDirty (state) {
            this.$emit('update:dirty', state)
        },

        addComment () {
            if (!this.canAddComments) {
                this.$swal('Error', 'No se pueden agregar comentarios', 'error')
                return
            }
            this.addingComment = true
        },

        async saveComment () {
            this.errors = ''
            let comment = this.record.comment.replace(/^\s+|\s+$/g, '')
            if (comment.length === 0) {
                this.record.comment = ''
                this.errors = 'Ingresa un comentario válido'
            } else {
                let loader = this.$loading.show()
                this.record.id = this.factoringCompany.id
                try {
                    await FactoringCompanyService.comment(this.record)
                    loader.hide()
                    await this.loadRecord(this.factoringCompany.id)
                } catch (error) {
                    console.error(error)
                    loader.hide()
                    let msg = error.data && error.data.message ? error.data.message : 'Error al aprobar empresa'
                    return this.$swal('Error', msg, 'error')
                }

                this.record = {}
                this.errors = ''
                this.addingComment = false
            }
        },

        cancelAddComment () {
            this.record = {}
            this.errors = ''
            this.addingComment = false
        }
    },

    computed: {
        canAddComments () {
            return Utils.userHasPerm('can_add_comment_factoring_company')
        }
    },

    watch: {
        addingComment (state) {
            this.gotDirty(state)
        }
    }
}
</script>
